



























































































































































































import { ColunaRelatorio, ViewRelatorio } from '@/models/views/ViewRelatorio'
import { AgGridState } from '@/models/views/AgGrid'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { SaveRelatorioUseCase } from '@/usecases'
import { DeleteRelatorioUseCase } from '@/usecases/relatorio/DeleteRelatorioUseCase'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AgGridVue } from 'ag-grid-vue'
import { LicenseManager } from 'ag-grid-enterprise'
import { AgGridComponenteDeImagem } from '@/api/aggrid/AgGridComponenteDeImagem'
import { AG_GRID_LOCALE_BR } from '@ag-grid-community/locale'
import { v4 as uuidv4 } from 'uuid'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import DialogoBuilderRelatorio from '@/components/dashboard/DialogoBuilderRelatorio.vue'
import { ehTemplateDoConstrutor } from '@/shareds/relatorio/visao-legada'

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-066566}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Almode}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Almode}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Almode}_need_to_be_licensed___{Almode}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{7_September_2025}____[v3]_[01]_MTc1NzE5OTYwMDAwMA==9c5f2e3bec6aeda6768b2994297ce2a8")

@Component({
	components: {
		AgGridVue,
		Confirmacao,
		DialogoBuilderRelatorio,
	},
})
export default class GridClassicoDeRelatorio extends Vue {
	@Prop({ type: Array, default: () => [] }) linhas!: object[]
	@Prop({ default: null }) relatorio!: ViewRelatorio | null
	@Prop({ type: Array, default: () => [] }) presets!: AgGridState[]
	@Prop({ type: Boolean, default: false }) carregandoPresets!: boolean
	@Prop({ type: Array, default: () => [] }) templates!: any[]
	@Prop({ type: Array, default: () => [] }) filtros!: any[]
	@Prop({ type: String, default: '#60269E' }) corPrimaria!: string
	@Prop({ type: String, default: '' }) empresa!: string
	@Prop({ type: Boolean, default: false }) podeGlobal!: boolean
	@Prop({ type: String, default: '' }) usuarioId!: string

	saveUseCase = new SaveRelatorioUseCase()
	deleteUseCase = new DeleteRelatorioUseCase()

	AG_GRID_LOCALE_BR = AG_GRID_LOCALE_BR

	gridApi: any = null
	gridVisible = true
	initialState: any = null
	presetSalvoSelecionadoGrid: AgGridState | null = null
	buscapresetSalvoGrid: any = null
	nomeDoPreset: string | null = null
	mostraDialogoDeSalvamentoDePreset = false
	salvandoPreset = false
	removendoPreset = false
	alturaDaColuna = 50
	dialogoBuilder = false
	mostrarSeletorDeTemplate = false
	templateSelecionadoParaGerar: any = null

	columnTypes = {
		currency: {
			width: 150,
			valueFormatter: this.currencyFormatter,
		},
		shaded: {
			cellClass: 'shaded-class',
		},
		imagem: {
			width: 500,
		},
	}

	statusBar = {
		statusPanels: [
			{ statusPanel: 'agTotalAndFilteredRowCountComponent' },
			{ statusPanel: 'agFilteredRowCountComponent' },
			{ statusPanel: 'agSelectedRowCountComponent' },
			{ statusPanel: 'agAggregationComponent' },
		],
	}

	sideBar = {
		toolPanels: [
			{
				id: 'columns',
				labelDefault: 'Editar',
				labelKey: 'colunas',
				iconKey: 'columns',
				toolPanel: 'agColumnsToolPanel',
				minWidth: 225,
				width: 225,
				maxWidth: 225,
			},
		],
		position: 'left',
	}

	defaultColDef = {
		flex: 1,
		minWidth: 100,
		enableRowGroup: true,
		enablePivot: true,
		filter: true,
	}

	autoGroupColumnDef = {
		minWidth: 300,
	}

	grandTotalRow = 'bottom'

	get deveObrigatoriamenteInformarVisao() {
		return UserLoginStore.permiteRegraDeNegocio('obrigatorio-selecionar-visao-de-relatorio')
	}

	get gridSideBar() {
		if (this.deveObrigatoriamenteInformarVisao) return false
		return this.sideBar
	}

	get gridRowGroupPanelShow() {
		return this.deveObrigatoriamenteInformarVisao ? 'never' : 'always'
	}

	get gridPivotPanelShow() {
		return this.deveObrigatoriamenteInformarVisao ? 'never' : 'always'
	}

	get presetsDeGrade(): AgGridState[] {
		return (this.presets || []).filter(preset => !ehTemplateDoConstrutor(preset))
	}

	get titulo(): string {
		return this.relatorio ? this.relatorio.nomeRelatorio : 'Relatório'
	}

	get templatesDoConstrutor(): any[] {
		return this.templates || []
	}

	get templatesParaPdf(): any[] {
		return this.templatesDoConstrutor.filter(template => !template.visaoLegada)
	}

	get opcoesDeTemplateParaGerar(): any[] {
		return [{ nome: 'Padrão (colunas atuais)', presetSalvo: null }, ...this.templatesParaPdf]
	}

	get templatePadrao(): any {
		const lista = this.templatesParaPdf
		if (!lista.length) return null
		return lista.find((t: any) => t.favorito && t.usuarioId === this.usuarioId)
			|| lista.find((t: any) => t.global)
			|| lista[0]
	}

	get colunasBuilder(): any[] {
		const primeiro: any = this.linhas[0] || {}
		return this.colunas
			.map(coluna => {
				const conf = this.colunasConfiguradas.find(c => c.colunaDaView == coluna)
				if (!conf) {
					return { header: coluna, field: coluna, numerico: typeof primeiro[coluna] === 'number', moeda: false, aggFunc: null, sequencia: Number.MAX_VALUE }
				}
				return {
					header: conf.nomeColuna,
					field: coluna,
					numerico: conf.tipoColuna === 'number',
					moeda: conf.tipoColuna === 'number' && conf.formatoExibicao === 'money',
					aggFunc: conf.tipoColuna === 'number' ? conf.totalizador || null : null,
					sequencia: conf.sequencia || Number.MAX_VALUE,
				}
			})
			.sort((a, b) => a.sequencia - b.sequencia)
			.map(({ sequencia, ...coluna }) => coluna)
	}

	get linhasParaPreview(): any[] {
		return (this.linhas as any[]).slice(0, 50)
	}

	get colunas(): string[] {
		if (this.linhas.length > 0) {
			return Object.keys(this.linhas[0])
		}
		return []
	}

	get colunasConfiguradas(): ColunaRelatorio[] {
		return this.relatorio ? this.relatorio.colunas : []
	}

	get colunasFormatadasAgGrid() {
		const colunaAgrupadora = this.relatorio ? this.relatorio.colunaAgrupadora : null

		const colunas = this.colunas.map(coluna => {
			const colunaConfiguradaEncontrada = this.colunasConfiguradas.find(colunaConfigurada => colunaConfigurada.colunaDaView == coluna)

			if (colunaConfiguradaEncontrada) {
				const agrupada = colunaAgrupadora === colunaConfiguradaEncontrada.colunaDaView

				if (colunaConfiguradaEncontrada.tipoColuna === 'number') {
					return {
						headerName: colunaConfiguradaEncontrada.nomeColuna,
						field: coluna,
						aggFunc: colunaConfiguradaEncontrada.totalizador,
						sequencia: colunaConfiguradaEncontrada.sequencia || Number.MAX_VALUE,
						type: this.definirFormatoDeExibicao(colunaConfiguradaEncontrada.formatoExibicao) ?
							[ this.definirFormatoDeExibicao(colunaConfiguradaEncontrada.formatoExibicao), 'rightAligned' ]
							:
							'rightAligned',
						rowGroup: agrupada,
						hide: agrupada,
						resizable: true,
						filter: 'agNumberColumnFilter',
						enableRowGroup: true,
						enablePivot: true,
						enableValue: true,
					}
				} else if (colunaConfiguradaEncontrada.tipoColuna === 'boolean') {
					return {
						headerName: colunaConfiguradaEncontrada.nomeColuna,
						field: coluna,
						sequencia: colunaConfiguradaEncontrada.sequencia || Number.MAX_VALUE,
						type: this.definirFormatoDeExibicao(colunaConfiguradaEncontrada.formatoExibicao),
						rowGroup: agrupada,
						hide: agrupada,
						resizable: true,
						filter: 'agSetColumnFilter',
					}
				} else if (colunaConfiguradaEncontrada.tipoColuna === 'date') {
					return {
						headerName: colunaConfiguradaEncontrada.nomeColuna,
						field: coluna,
						sequencia: colunaConfiguradaEncontrada.sequencia || Number.MAX_VALUE,
						type: 'rightAligned',
						rowGroup: agrupada,
						hide: agrupada,
						resizable: true,
						filter: 'agTextColumnFilter',
					}
				} else if (colunaConfiguradaEncontrada.tipoColuna === 'image') {
					return {
						headerName: colunaConfiguradaEncontrada.nomeColuna,
						field: coluna,
						sequencia: colunaConfiguradaEncontrada.sequencia || Number.MAX_VALUE,
						rowGroup: agrupada,
						hide: agrupada,
						cellRenderer: AgGridComponenteDeImagem,
						resizable: true,
						type: 'imagem',
						filter: 'agTextColumnFilter',
					}
				}

				return {
					headerName: colunaConfiguradaEncontrada.nomeColuna,
					field: coluna,
					sequencia: colunaConfiguradaEncontrada.sequencia || Number.MAX_VALUE,
					rowGroup: agrupada,
					hide: agrupada,
					resizable: true,
					filter: 'agTextColumnFilter',
				}
			}

			return {
				headerName: coluna,
				field: coluna,
				sequencia: Number.MAX_VALUE,
				resizable: true,
				filter: 'agTextColumnFilter',
			}
		})

		colunas.sort((a, b) => a.sequencia - b.sequencia)

		return colunas.map(coluna => {
			const { sequencia, ...colunaSemSequencia } = coluna
			return colunaSemSequencia
		})
	}

	created() {
		this.ajustarAlturaDaLinha()
	}

	ajustarAlturaDaLinha() {
		const possuiImagem = this.colunasConfiguradas.some(coluna => coluna.tipoColuna === 'image')
		this.alturaDaColuna = possuiImagem ? 90 : 50
	}

	currencyFormatter(params) {
		if (params.value == null) {
			return ''
		}
		const formatador = new Intl.NumberFormat('pt-BR', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2,
		})
		return 'R$ ' + formatador.format(parseFloat(Number(params.value).toFixed(2)))
	}

	definirFormatoDeExibicao(formatoDeExibicao: string | null) {
		switch(formatoDeExibicao) {
			case 'money':
				return 'currency'
			default:
				return formatoDeExibicao
		}
	}

	filtrarPresetSalvo(item: any, queryText: any, itemText: any) {
		if (item.header) return false

		const hasValue = val => val != null ? val : ''

		const text = hasValue(itemText)
		const query = hasValue(queryText)

		return text.toString()
			.toLowerCase()
			.indexOf(query.toString().toLowerCase()) > -1
	}

	onGridReady(params) {
		this.gridApi = params.api
	}

	onFilterTextBoxChanged(valor: string) {
		if (!this.gridApi) return
		this.gridApi.setGridOption('quickFilterText', valor)
	}

	exportarExcel() {
		if (!this.gridApi) return
		this.gridApi.exportDataAsExcel()
	}

	linhasDoGridOrdenadas(cfg: any): any[] {
		const linhasDoGrid: any[] = []
		if (this.gridApi && this.gridApi.forEachNodeAfterFilterAndSort) {
			this.gridApi.forEachNodeAfterFilterAndSort((n: any) => { if (n.data) linhasDoGrid.push(n.data) })
		}
		const base = linhasDoGrid.length ? linhasDoGrid : (this.linhas as any[]).slice()

		if (cfg.ordenarField) {
			base.sort((a: any, b: any) => {
				const x = a[cfg.ordenarField]
				const y = b[cfg.ordenarField]
				const r = typeof x === 'number' && typeof y === 'number'
					? x - y
					: String(x ?? '').localeCompare(String(y ?? ''), 'pt-BR', { numeric: true })
				return cfg.ordenarDir === 'desc' ? -r : r
			})
		}
		return base
	}

	aoGerarDoConstrutor(cfg: any) {
		this.$emit('gerar', { ...cfg, linhas: this.linhasDoGridOrdenadas(cfg), filtros: this.filtros })
	}

	cfgDeConfig(config: any): any {
		const ordem: string[] = config.ordem || []
		const porField: any = {}
		this.colunasBuilder.forEach((c: any) => { porField[c.field] = c })
		const qf: string[] = config.quebraFields || (config.quebraField ? [config.quebraField] : [])
		const colunasOrd = ordem.length ? ordem.map((f: string) => porField[f]).filter(Boolean) : this.colunasBuilder
		const colunas = colunasOrd.filter((c: any) => !qf.includes(c.field)).map((c: any) => ({ header: c.header, field: c.field, numerico: c.numerico, moeda: c.moeda, aggFunc: c.aggFunc }))
		const imgCol = colunasOrd.find((c: any) => /(imagem|foto|img|thumb|avatar)/i.test((c.header || '') + ' ' + (c.field || '')))
		return { colunas, quebraFields: qf, ordenarField: config.ordenarField || null, ordenarDir: config.ordenarDir || 'asc', orientacao: config.orientacao || 'paisagem', subtotais: config.subtotais !== false, totalGeral: config.totalGeral !== false, pivot: config.pivot || null, formato: config.formato || 'tabela', imagemField: config.imagemField || (imgCol ? imgCol.field : null) }
	}

	gerarDireto() {
		const templates = this.templatesParaPdf
		if (!templates.length) {
			this.gerarRelatorioComTemplate(null)
			return
		}
		if (templates.length === 1) {
			this.gerarRelatorioComTemplate(templates[0])
			return
		}
		this.templateSelecionadoParaGerar = this.templatePadrao
		this.mostrarSeletorDeTemplate = true
	}

	gerarRelatorioComTemplate(tpl: any) {
		this.mostrarSeletorDeTemplate = false
		if (tpl && tpl.presetSalvo) {
			this.aoGerarDoConstrutor(this.cfgDeConfig(tpl.presetSalvo.config || tpl.presetSalvo))
			return
		}
		this.aoGerarDoConstrutor({
			colunas: this.colunasBuilder.map((c: any) => ({ header: c.header, field: c.field, numerico: c.numerico, moeda: c.moeda, aggFunc: c.aggFunc })),
			quebraFields: [], ordenarField: null, ordenarDir: 'asc', orientacao: 'paisagem', subtotais: true, totalGeral: true,
		})
	}

	@Watch('presetSalvoSelecionadoGrid')
	restaurarPreset() {
		const state = this.presetSalvoSelecionadoGrid?.presetSalvo
		this.gridVisible = false
		setTimeout(() => {
			this.initialState = state
			this.gridVisible = true
		})
	}

	fecharSalvamentoDePreset() {
		this.mostraDialogoDeSalvamentoDePreset = false
		this.nomeDoPreset = null
	}

	async salvarPreset() {
		if (!this.gridApi) return
		if (!this.relatorio) return
		if (!this.nomeDoPreset || this.nomeDoPreset.trim() === '') {
			AlertModule.setError('Informe um nome para a visão')
			return
		}

		const estadoAtual = {
			id: uuidv4(),
			nome: this.nomeDoPreset,
			presetSalvo: this.gridApi.getState(),
			viewRelatorioId: this.relatorio.id,
			usuarioId: UserLoginStore.usuario?.id || '',
		} as AgGridState

		try {
			this.salvandoPreset = true
			await this.saveUseCase.salvarPreset(estadoAtual)
		} catch(error: any) {
			AlertModule.setError(error)
		} finally {
			this.salvandoPreset = false
			this.fecharSalvamentoDePreset()
			this.$emit('recarregar-presets')
		}
	}

	async removerPresetSalvo(preset: AgGridState) {
		if (!preset.id) return
		try {
			this.removendoPreset = true
			await this.deleteUseCase.removerPreset(preset.id)
			if (this.presetSalvoSelecionadoGrid && this.presetSalvoSelecionadoGrid.id === preset.id) {
				this.presetSalvoSelecionadoGrid = null
			}
			this.$emit('recarregar-presets')
		} catch(error: any) {
			AlertModule.setError(error)
		} finally {
			this.removendoPreset = false
		}
	}
}
